import Controller, { inject as controller } from '@ember/controller';

export default class PartsBuildHistoryMarriagesController extends Controller {
  @controller('parts/build-history') buildHistoryController;

  get buildStatusesWithMarriages() {
    return this.buildHistoryController.buildStatuses.filter(item => item.hasMarriages);
  }
}
